import json from './sprite.js';

export default {
    handle: 'ENG_SPS9-ArtSupplies',
    label: 'en_SPS9-ArtSupplies_225002144',
    json,
};
